import Axios from 'axios'
import { ALERTS_URL, getErrorMessage } from '@/main'

const state = {
  stateAlertsResult: null,
}

const getters = {
  alertsResult: (state) => {
    return state.stateAlertsResult
  },
}

const mutations = {
  setAlertsResult: (state, payload) => {
    state.stateAlertsResult = payload
  },
  resetAlertsResult: (state) => {
    state.stateAlertsResult = null
  },
}

const actions = {}

export function prepareAlertsMetadata(context) {
  Axios.get(`${ALERTS_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { alerts: { category: 'module' } })
    })
    .catch((error) => {
      console.warn('ALERTS module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { alerts: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
